import ContactPage from "../components/contact-page/contact-page";

export default function GetInTouch() {
    return (
        <ContactPage />
    )
}